import React from "react";
import { Row, Col } from "react-bootstrap";
import parse from "html-react-parser";
import GetParsedDate from "../../shared/GetParsedDate";

const DisplayEmail = ({ email, bhinaMeeting }) => {
  if (typeof email.id != "undefined") {
    return (
      <>
        <div className="card container p-3 my-3 border" id="mail-card">
          <div className="card-header">
            <h3 style={{ textAlign: "center" }}>
              הזמנה של חבר ועדה
              <br /> ועדת הבחינה מספר: {bhinaMeeting.mt_num} מיום:{" "}
              {bhinaMeeting.mt_date} שעה:{" "}
              {bhinaMeeting.start_time.substring(0, 5)}
            </h3>
          </div>
          <div className="card-body">
            <Row className="mt-4">
              <Col>
                <label htmlFor="id" className="black-title">
                  {" "}
                  מספר ההודעה:{" "}
                </label>
                <div style={{ border: "1px solid gray" }}>{email?.id}</div>
              </Col>

              <Col>
                <label htmlFor="id" className="black-title">
                  {" "}
                  תאריך וזמן שליחת ההודעה:{" "}
                </label>
                <div style={{ border: "1px solid gray" }}>
                  {GetParsedDate({ strDate: email?.send_date, withTime: true })}
                </div>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col>
                <label htmlFor="id" className="black-title">
                  {" "}
                  ההודעה נשלחה ל:{" "}
                </label>
                <div style={{ border: "1px solid gray" }}>
                  {email?.member_name}
                </div>
              </Col>
              <Col>
                <label htmlFor="id" className="black-title">
                  {" "}
                  ההודעה נשלחה ע"י:{" "}
                </label>
                <div style={{ border: "1px solid gray" }}>{email?.sender}</div>
              </Col>
            </Row>

            <Row className="mt-4">
              <label htmlFor="id" className="black-title">
                {" "}
                תוכן ההודעה:{" "}
              </label>
              <div style={{ border: "1px solid gray" }}>
                {parse(email?.content ? email?.content : "")}
              </div>
            </Row>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <div
        className="text-center"
        style={{
          fontWeight: "bold",
          fontSize: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh", // Set the height of the container div accordingly
        }}
      >
        {" "}
        בחר דואר להצגה{" "}
      </div>
    );
  }
};

export default DisplayEmail;
